import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import moment from "moment";

const ProjectEvalFeedbackForm = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [managerAPIData, setManagerAPIData] = useState([]);
    const [empHeaderData, setEmpHeaderData] = useState({});

    useEffect(() => {
        dispatch(updateNavbarHeading("Employee Feedback Details"));
        fetchGetAPI();
    }, [dispatch]);

    const fetchGetAPI = async () => {
        try {
            const response = await GetServiceCaller(`${API_URL}manager-feedback-details/${id}`);
            if (response?.status === 200) {
                const data = response.data.data || {};
                setEmpHeaderData(data.empDetails || {});
                setManagerAPIData(data.managerfeedback || []);
            }
        } catch (error) {
            console.error("Error fetching manager feedback:", error);
        }
    };

    const nestedData = useMemo(() => {
        return managerAPIData.reduce((acc, item) => {
            acc[item.ManagerID] = acc[item.ManagerID] || [];
            acc[item.ManagerID].push(item);
            return acc;
        }, {});
    }, [managerAPIData]);

    const nestedDataDate = useMemo(() => {
        return Object.entries(nestedData).reduce((result, [managerId, items]) => {
            result[managerId] = items.reduce((acc, item) => {
                acc[item.ReviewDate] = acc[item.ReviewDate] || [];
                acc[item.ReviewDate].push(item);
                return acc;
            }, {});
            return result;
        }, {});
    }, [nestedData]);

    return (
        <div className="container-fluid py-3">
            <div className="card shadow-sm border-0">
                <div className="card-body">

                    <div className="row mb-4">
    <div className="col-md-4 mb-1 d-flex">
        <h6 className="text-muted fw-bold">Emp ID&nbsp;:&nbsp;</h6>
        <p className="">{empHeaderData?.code || "N/A"}</p>
    </div>
    <div className="col-md-4 mb-1 d-flex">
        <h6 className="text-muted fw-bold">Employee:&nbsp;</h6>
        <p className="">{empHeaderData?.employee || "N/A"}</p>
    </div>
    <div className="col-md-4 mb-1 d-flex">
        <h6 className="text-muted fw-bold">Immediate Superior:&nbsp;</h6>
        <p className="">{empHeaderData?.manager || "N/A"}</p>
    </div>
</div>



                    <ul className="nav nav-tabs" id="managerTab" role="tablist">
                        {Object.entries(nestedData).map(([managerId, managerItems], index) => (
                            <li className="nav-item" role="presentation" key={managerId}>
                                <button
                                    className={`nav-link ${index === 0 ? "active" : ""}`}
                                    id={`manager-${managerId}-tab`}
                                    data-bs-toggle="tab"
                                    data-bs-target={`#manager-${managerId}`}
                                    type="button"
                                    role="tab"
                                    aria-controls={`manager-${managerId}`}
                                    aria-selected={index === 0 ? "true" : "false"}
                                >
                                    {managerItems[0]?.ManagerName || "Unknown"}
                                </button>
                            </li>
                        ))}
                    </ul>

                    <div className="tab-content mt-3" id="managerTabContent">
                        {Object.entries(nestedData).map(([managerId, managerItems], index) => (
                            <div
                                key={managerId}
                                className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
                                id={`manager-${managerId}`}
                                role="tabpanel"
                                aria-labelledby={`manager-${managerId}-tab`}
                            >
                                <ul className="nav nav-pills mb-3" id={`dateTab-${managerId}`} role="tablist">
                                    {Object.entries(nestedDataDate[managerId] || {}).map(([reviewDate], dateIndex) => (
                                        <li className="nav-item" role="presentation" key={reviewDate}>
                                            <button
                                                className={`nav-link ${dateIndex === 0 ? "active" : ""}`}
                                                id={`manager-${managerId}-date-${dateIndex}-tab`}
                                                data-bs-toggle="pill"
                                                data-bs-target={`#manager-${managerId}-date-${dateIndex}`}
                                                type="button"
                                                role="tab"
                                                style={{ borderRadius: "30px" }}
                                                aria-controls={`manager-${managerId}-date-${dateIndex}`}
                                                aria-selected={dateIndex === 0 ? "true" : "false"}
                                            >
                                                {moment(reviewDate).format("DD MMM YYYY")}
                                            </button>
                                        </li>
                                    ))}
                                </ul>

                                <div className="tab-content" id={`dateTabContent-${managerId}`}>
                                    {Object.entries(nestedDataDate[managerId] || {}).map(([reviewDate, items], dateIndex) => (
                                        <div
                                            key={reviewDate}
                                            className={`tab-pane fade ${dateIndex === 0 ? "show active" : ""}`}
                                            id={`manager-${managerId}-date-${dateIndex}`}
                                            role="tabpanel"
                                            aria-labelledby={`manager-${managerId}-date-${dateIndex}-tab`}
                                        >
                                            <Table responsive className="table-borderless">
                                                <tbody>
                                                    {items.map((question, qIndex) => (
                                                        <tr key={qIndex}>
                                                            <td>
                                                                <div className="card mb-3 shadow-sm border-0 rounded-3">
                                                                    <div className="card-header text-white fw-bold" style={{ backgroundColor: "#27568c" }}>
                                                                        {qIndex + 1}) {question.Title}
                                                                    </div>
                                                                    <div className="card-body" style={{ backgroundColor: "#f3f3f3" }}>
                                                                        <p className="text-muted fw-bold ps-3">{question.Question}</p>
                                                                        <div className="ps-3">
                                                                            {question.QuestionType === 1342 ? (
                                                                                <div>
                                                                                    <textarea
                                                                                        className="form-control mb-2"
                                                                                        rows="3"
                                                                                        value={question.EmployeeAnswer || ""}
                                                                                        disabled
                                                                                        style={{ backgroundColor: "#ffffff" }}
                                                                                    />
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control"
                                                                                        value={question.Rating || ""}
                                                                                        min="1"
                                                                                        max="10"
                                                                                        step="0.5"
                                                                                        disabled
                                                                                        placeholder="Rating (1-10)"
                                                                                        style={{ backgroundColor: "#ffffff" }}
                                                                                    />
                                                                                </div>
                                                                            ) : question.QuestionType === 1343 ? (
                                                                                <div>
  {[question.Option1, question.Option2, question.Option3, question.Option4]
    .filter(Boolean)
    .map((option, optIndex) => (
      <div className="form-check mb-2 ps-3" key={optIndex}>
        <input
          className="form-check-input"
          type="radio"
          name={`question-${managerId}-${dateIndex}-${qIndex}`}
          value={option}
          disabled
          checked={question.EmployeeAnswer === option} // <-- Correct property
        />
        <label className="form-check-label">{option}</label>
      </div>
    ))}
</div>

                                                                            ) : (
                                                                                <p className="text-muted">No answer available</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-end mt-3">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => window.history.back()}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectEvalFeedbackForm;
